export default {
  showAlarms: 'Zobraziť alarmy',
  showStages: 'Zobraziť fázy',
  showMarkers: 'Zobraziť značky',
  showHoverPoints: 'Zobraziť body pod kurzorom',
};
